<footer class="py-3 my-4 navbar-dark bg-ligth footer-ligth">
  <ul class="nav justify-content-center border-bottom pb-3 mb-3">
    <li class="nav-item"><a [routerLink]="['home']" class="nav-link px-2 text-muted font-color">Home</a></li>
    <li class="nav-item"><a [routerLink]="['sobre']" class="nav-link px-2 text-muted font-color">Sobre</a></li>
    <li class="nav-item"><a [routerLink]="['projetos']" class="nav-link px-2 text-muted font-color">Projetos</a></li>
    <li class="nav-item"><a [routerLink]="['contato']" class="nav-link px-2 text-muted font-color">Contato</a></li>
  </ul>
  <p class="text-center text-muted">© 2021 Ippo Tecnologia</p>
</footer>
